import GenericAPI, { CONTENT_TYPE } from "../GenericApi";
class EventApi extends GenericAPI {

    EVENT_TYPES_ENDPOINT="/api/commonMaster"
    EVENT_ENDPOINT="/api/eventInformation"
    ADD_EVENT_DESCRIPTION_ENDPOINT="/api/eventInformation/addEventDescription"
    ADD_EVENT_BUDGET_ENDPOINT="/api/eventInformation/addEventbudget"
    ADD_EVENT_IMAGE_ENDPOINT="/api/eventInformation/addEventImage"
    DELETE_EVENT_IMAGE_ENDPOINT="/api/eventInformation/DeleteEventImage"
    BUDGET_ENDPOINT="/api/budget"
    GET_FAVORITE_SUPPLIER_ENDPOINT="/api/businessDetail/getFavoriteBusiness"
    ADD_OR_REMOVE_FAVORITE_SUPPLIER_LIST="/api/businessDetail/favoriteBusiness"
    GET_SUPPLIER_ENDPOINT="/api/businessDetail/getBusiness"
    GET_EVENT_GUEST_LIST="/api/guestInformation"
    INVITE_ALL_GUEST="/api/guestInformation/guestIsInvite"
    TODO_ITEM="/api/toDo"


    // add budget item
    async addBudgetItem(payload) {
        return this.post(this.BUDGET_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true)
    }
    // task mark as complete
    async markAsComplete(payload) {
        return this.put(this.TODO_ITEM, payload, CONTENT_TYPE.URLENCODED, true)
    }

    // get task list
    async getTaskList(eventId) {
        const payload = {
            eventId
        }
        return this.get(this.TODO_ITEM, payload, true)
    }

    // add new task
    async addTaskInList(payload) {
        return this.post(this.TODO_ITEM, payload, CONTENT_TYPE.URLENCODED, true)
    }

    async inviteAllGuest(eventId) {
        const payload = {
            eventId,
            deviceType: "Android"
        }
        return this.post(this.INVITE_ALL_GUEST, payload, CONTENT_TYPE.URLENCODED, true)
    }

     // to get Favorite Supplier list
    async getFavoriteSupplierList(userId){
        const payload = {
            userId
        }
        return this.get(this.GET_FAVORITE_SUPPLIER_ENDPOINT, payload, true)
    }

    //get event guest list
    async getGuestList(eventId){
        const payload ={
            eventId
        }
        return this.get(this.GET_EVENT_GUEST_LIST, payload, true)
    }

    // add guest 
    async addGuesttolist(payload){
        return this.post(this.GET_EVENT_GUEST_LIST, payload, CONTENT_TYPE.URLENCODED, true)
    }

    // add or remove favourite supplier
    async addOrRemovefavoriteSupplierList(userId, businessId, status){
        const payload = {
            userId,
            businessId,
            status
        }
        return this.post(this.ADD_OR_REMOVE_FAVORITE_SUPPLIER_LIST, payload, CONTENT_TYPE.URLENCODED, true)
    }

    async getSupplierList(eventId, searchText, fromPage, toPage, categoryId){
        const payload = {
            eventId,
            searchText,
            fromPage,
            toPage,
            categoryId
        }
        return this.get(this.GET_SUPPLIER_ENDPOINT, payload, true)
    }

    async getEventTypes() {
        return this.get(this.EVENT_TYPES_ENDPOINT, null, true);
    }

    async addEvent(data) {
        return this.post(this.EVENT_ENDPOINT, data, CONTENT_TYPE.MULTIPART, true);
    }

    async getEvent(userId) {

        const payload =  {
            userId
        }
        return this.get(this.EVENT_ENDPOINT, payload, true);
    }

    async deleteEvent(eventId) {
        const payload =  {
            eventId
        }
        return this.delete(this.EVENT_ENDPOINT, payload, true);
    }

    async addEventDescription(payload) {
        return this.post(this.ADD_EVENT_DESCRIPTION_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true);
    }

    async addEventBudget(data) {
        const { eventId, budget } = data;
        const payload = {
            eventId,
            budget
        };
        return this.post(this.ADD_EVENT_BUDGET_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true);
    }

    async addEventImage(data) {
        return this.post(this.ADD_EVENT_IMAGE_ENDPOINT, data, CONTENT_TYPE.MULTIPART, true);
    }

    async deleteEventImage(data) {
        const { eventId,id,imageType } = data;
        const payload = {
            eventId,
            imageId:id,
            typeImage:imageType
        };
        return this.post(this.DELETE_EVENT_IMAGE_ENDPOINT, payload, CONTENT_TYPE.URLENCODED, true);
    }

    async getBudget(eventId) {
        const payload =  {
            eventId
        }
        return this.get(this.BUDGET_ENDPOINT, payload, true);
    }

    async addBudget(data) {
        const {  eventId, itemName, price, buyerId } = data;
        const payload =  {
            eventId,
            itemName,
            price,
            buyerId
        }
        return this.get(this.BUDGET_ENDPOINT, payload, true);
    }
}

export default new EventApi();
